<template>
    <div class="mx-1 main-background">
        <v-col v-if="lessons == null" class="loading d-flex">
            <v-progress-circular
                :size="60"
                :width="7"
                color="academia-primary"
                class="ma-auto"
                indeterminate
            ></v-progress-circular>
        </v-col>
        <v-row v-else>
            <v-col>
                <v-card flat outlined>
                    <v-card-text>
                        <v-toolbar dense flat>
                            <v-icon>
                                mdi-video
                            </v-icon>
                            <v-select
                                v-model="lesson_selected"
                                color="academia-primary"
                                :items="lessons"
                                item-text="name"
                                item-value="id"
                                hide-details
                                flat
                                solo
                                dense
                                label="Selecciona una clase"
                            ></v-select>
                        </v-toolbar>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="students.length > 0 && lesson_selected">
            <v-col>
                <v-toolbar flat>
                    <p class="my-1 font-weight-bold ml-3">Alumnos</p>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        dark
                        v-if="lesson_selected"
                        :disabled="
                            lessons.find((l) => l.id === lesson_selected)
                                .type === ONLINE
                        "
                        @click="save"
                        >Guardar</v-btn
                    >
                </v-toolbar>
                <v-list>
                    <v-divider></v-divider>
                    <template v-for="(student, index) in students">
                        <v-list-item class="rounded-lg py-2" :key="student.id">
                            <v-list-item-avatar
                                color="primary"
                                tile
                                class="rounded-lg"
                            >
                                <v-icon dark>mdi-account-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ student.name }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-caption">
                                    Nombre
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-chip-group>
                                    <v-chip
                                        label
                                        outlined
                                        color="success"
                                        @click="
                                            changeState(student.id, ATTENDANCE)
                                        "
                                        :class="{
                                            active:
                                                attendances_ui.find(
                                                    (s) => s.id === student.id
                                                ).attendance == ATTENDANCE,
                                        }"
                                        :disabled="
                                            lessons.find(
                                                (l) => l.id === lesson_selected
                                            ).type === ONLINE
                                        "
                                    >
                                        Asistencia
                                    </v-chip>
                                    <v-chip
                                        label
                                        outlined
                                        color="warning"
                                        @click="changeState(student.id, RETARD)"
                                        :class="{
                                            active:
                                                attendances_ui.find(
                                                    (s) => s.id === student.id
                                                ).attendance == RETARD,
                                        }"
                                        :disabled="
                                            lessons.find(
                                                (l) => l.id === lesson_selected
                                            ).type === ONLINE
                                        "
                                    >
                                        Retardo
                                    </v-chip>
                                    <v-chip
                                        label
                                        outlined
                                        color="warning"
                                        @click="
                                            changeState(
                                                student.id,
                                                NO_ATTENDANCE_JUSTIFY
                                            )
                                        "
                                        :class="{
                                            active:
                                                attendances_ui.find(
                                                    (s) => s.id === student.id
                                                ).attendance ==
                                                NO_ATTENDANCE_JUSTIFY,
                                        }"
                                        :disabled="
                                            lessons.find(
                                                (l) => l.id === lesson_selected
                                            ).type === ONLINE
                                        "
                                    >
                                        Falta
                                        <v-icon size="small">mdi-cross</v-icon>
                                    </v-chip>
                                    <v-chip
                                        label
                                        outlined
                                        color="error"
                                        @click="
                                            changeState(
                                                student.id,
                                                NO_ATTENDANCE
                                            )
                                        "
                                        :class="{
                                            active:
                                                attendances_ui.find(
                                                    (s) => s.id === student.id
                                                ).attendance == NO_ATTENDANCE,
                                        }"
                                        :disabled="
                                            lessons.find(
                                                (l) => l.id === lesson_selected
                                            ).type === ONLINE
                                        "
                                    >
                                        Falta
                                    </v-chip>
                                </v-chip-group>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider :key="index"></v-divider>
                    </template>
                </v-list>
            </v-col>
        </v-row>
        <div v-else-if="students.length > 0" class="no-students d-flex">
            <div class="ma-auto font-weight-bold blue-grey--text text-center">
                <v-icon x-large class="font-weight-bold blue-grey--text"
                    >mdi-clipboard-text</v-icon
                >
                <p>Sin clase seleccionada</p>
            </div>
        </div>
        <div v-else class="no-students d-flex">
            <div class="ma-auto font-weight-bold blue-grey--text text-center">
                <v-icon x-large class="font-weight-bold blue-grey--text"
                    >mdi-account-supervisor-circle</v-icon
                >
                <p>No hay alumnos registrados</p>
            </div>
        </div>
    </div>
</template>

<script>
import { ATTENDANCE } from '../../plugins/criteria-types'
import { ONLINE } from '../../plugins/lessons-types'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'Students',
    computed: {
        ...mapState({
            lessons_ready: (state) => state.teacher.lessons !== null,
            lessons: (state) =>
                state.teacher.lessons
                    ? state.teacher.lessons.filter(
                          (lesson) => lesson.type !== ONLINE
                      )
                    : [],
            students: (state) =>
                state.teacher.course.students
                    ? state.teacher.course.students
                    : [],
            attendances: (state) => state.teacher.course.progress[ATTENDANCE],
            attendances_ui(state) {
                const saved_attendances = state.teacher.course.progress[
                    ATTENDANCE
                ]
                    ? state.teacher.course.progress[ATTENDANCE][
                          this.lesson_selected
                      ]
                    : undefined

                const actual_values = this.attendances_actual
                    ? this.attendances_actual
                    : []

                const attendances_result = state.teacher.course.students.map(
                    (student) => {
                        let attendance = { id: student.id, attendance: null }

                        let user_attendance = saved_attendances?.find(
                            (attend) => attend.user === student.id
                        )
                        if (user_attendance) {
                            const {
                                out_of_time,
                                no_attendance,
                                justify,
                            } = user_attendance
                            attendance.attendance = this.ATTENDANCE
                            if (out_of_time) attendance.attendance = this.RETARD
                            if (no_attendance && !justify)
                                attendance.attendance = this.NO_ATTENDANCE
                            if (no_attendance && justify)
                                attendance.attendance = this.NO_ATTENDANCE_JUSTIFY
                        }

                        const user_in_actual = actual_values.find(
                            (v) => v.user === student.id
                        )
                        if (user_in_actual)
                            attendance.attendance = user_in_actual.value
                        return attendance
                    }
                )

                return attendances_result
            },
        }),
    },
    data() {
        return {
            lesson_selected: null,
            attendances_actual: [],
            ATTENDANCE: 'ATTENDANCE',
            RETARD: 'RETARD',
            NO_ATTENDANCE: 'NO_ATTENDANCE',
            NO_ATTENDANCE_JUSTIFY: 'NO_ATTENDANCE_JUSTIFY',
            ONLINE,
        }
    },
    methods: {
        ...mapActions({
            setAttendance: 'teacher/setAttendances',
            getLessons: 'teacher/fetchLessons',
        }),
        changeState(user, value) {
            const index = this.attendances_actual.findIndex(
                (v) => v.user === user
            )
            if (index >= 0) this.attendances_actual.splice(index, 1)
            this.attendances_actual.push({ user, value })
        },
        async save() {
            const values = []
            this.attendances_ui.forEach((att) => {
                if (att.attendance === this.ATTENDANCE)
                    values.push({ user: att.id })
                else if (att.attendance === this.RETARD)
                    values.push({ user: att.id, out_of_time: true })
                else if (att.attendance === this.NO_ATTENDANCE)
                    values.push({ user: att.id, no_attendance: true })
                else if (att.attendance === this.NO_ATTENDANCE_JUSTIFY)
                    values.push({
                        user: att.id,
                        no_attendance: true,
                        justify: true,
                    })
            })

            await this.setAttendance({ id: this.lesson_selected, data: values })
        },
    },
    watch: {
        lesson_selected() {
            this.attendances_actual = []
        },
    },
    async mounted() {
        if (this.lessons.length === 0) await this.getLessons()
    },
}
</script>

<style scoped>
.no-students {
    height: 50vh;
}
.v-chip.v-chip--outlined.v-chip.v-chip.active.success {
    color: white !important;
    background-color: var(--v-success-base) !important;
}
.v-chip.v-chip--outlined.v-chip.v-chip.active.warning {
    color: white !important;
    background-color: var(--v-warning-base) !important;
}
.v-chip.v-chip--outlined.v-chip.v-chip.active.error {
    color: white !important;
    background-color: var(--v-error-base) !important;
}
.v-chip--disabled {
    opacity: 1 !important;
}
</style>
